import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService } from './../../shared';

import { ContactFormComponent } from './../contact-form';

@Component({
  selector: 'bulk-data-feeds',
  template: require('./data-feeds.component.html'),
  styles: [require('./data-feeds.component.scss'), require('.//../static.scss')],
})
export class DataFeedsComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService) {
  }

  title = 'Sailing Schedules, Vessel and Carrier Data Feeds - Linescape';
  description = 'Liner shipping schedules, routes and vessel data filtered by port, vessel or carrier integrate with your IT system, by API or FTP.';
  
  ngOnInit() {
    this.seo.set(this.title, this.description);
  }


  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/data-feeds/data-feeds.component.ts